import React from "react";
import configData from "../config.json"

export default function Spinner(prop) {
    return (
        <div className={`d-flex justify-content-center align-items-center vh-100 bg-white loading-spinner ${prop.show === true ? 'a' : 'd-none'}`}>
            <img src={`../resources/${configData.COMPANY}/spinner.svg`} alt="" />
        </div>
    );
}